import { FC } from "react";

export const HeaderActions: FC = () => (
  <div className="HeaderActions">

  </div>
);
